module.exports = __webpack_public_path__ + "img/mobile-7.8d783b2a.jpg";